import { defineComponent, computed, onBeforeMount, watch } from '@vue/composition-api';
import dayjs from 'dayjs';
import useStore from '../store';
import { isInApp } from '@/utils/yoda';
export default defineComponent({
  components: {},
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  setup: function setup(props, ctx) {
    var store = useStore();
    var nowTime = new Date().getTime();
    var isActive = computed(function () {
      var _store$activeVenue;

      return ((_store$activeVenue = store.activeVenue) === null || _store$activeVenue === void 0 ? void 0 : _store$activeVenue.venueId) === props.item.venueId;
    });
    var isLocked = computed(function () {
      return props.item.openTime > nowTime;
    });
    var style = computed(function () {
      var background = 'rgba(0, 0, 0, 1)';
      var color = 'rgba(255, 255, 255, 1)';

      if (isActive.value) {
        color = 'rgba(0, 0, 0, 1)';
        background = 'rgba(255, 255, 255, 1)';
      }

      return {
        '--color': color,
        '--background': background,
        '--item-main-background': props.item.mainBackground
      };
    });

    var setBrowesedTimeout = function setBrowesedTimeout() {
      if (!isInApp) {
        return;
      }

      var timeout; // 设置浏览

      watch(function () {
        return [isActive.value, isLocked.value, props.item.browesed];
      }, function () {
        timeout && clearTimeout(timeout);

        if (isActive.value && !isLocked.value && !props.item.browesed) {
          timeout = setTimeout(function () {
            store.setBrowesed(props.item.venueId);
          }, 2000);
        }
      }, {
        immediate: true
      });
    };

    onBeforeMount(function () {
      setBrowesedTimeout();
    });
    var formatedTime = computed(function () {
      return dayjs(props.item.openTime).format('DD/MM');
    });

    var handleProgressItemClick = function handleProgressItemClick() {
      store.changeActiveVenueIndexById(props.item.venueId);
    };

    return {
      formatedTime: formatedTime,
      style: style,
      isLocked: isLocked,
      isActive: isActive,
      handleProgressItemClick: handleProgressItemClick
    };
  }
});